import { useNavigate } from 'react-router-dom';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * #72: what volunteering means. Everyone is a beneficiary (decided 2026-10-04);
 * volunteering adds the volunteer role on top. Shown at the top of /vol and on
 * the login screen when the visitor came from /vol, with a way out to
 * «طلب علاج» (/request-treatment) for someone who only wants treatment.
 */
export function VolunteerScopeNotice({ className }: { className?: string }) {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const goToBeneficiary = () => {
    // Someone who reached login via /vol would otherwise be sent back to the
    // volunteer form after signing in.
    try {
      if (sessionStorage.getItem('redirectAfterLogin') === '/vol') {
        sessionStorage.removeItem('redirectAfterLogin');
      }
    } catch {
      // storage unavailable — nothing to clear
    }
    navigate('/request-treatment');
  };

  return (
    // A flex row rather than <Alert>: Alert pins its icon with `left-4`,
    // which overlaps the text in RTL.
    <div role="note" className={cn('flex gap-3 rounded-lg border border-primary/30 bg-primary/5 p-4 text-sm', className)}>
      <Info className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" aria-hidden="true" />
      <div className="space-y-1">
        <p className="font-semibold text-foreground">{t('volunteerRegistration.scope.title')}</p>
        <p className="text-muted-foreground">{t('volunteerRegistration.scope.body')}</p>
        <button
          type="button"
          onClick={goToBeneficiary}
          className="font-medium text-primary underline underline-offset-4 hover:no-underline"
        >
          {t('volunteerRegistration.scope.beneficiaryLink')}
        </button>
      </div>
    </div>
  );
}
